export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5508.1513faeb.jpg";